// components/ui/input.jsx
import React from "react";
import classNames from "classnames";

const Input = ({ className, ...props }) => {
  return (
    <input
      className={classNames(
        " pr-2 py-2.5 w-full text-sm rounded-full bg-white border focus:outline-none focus:ring-1 focus:ring-red-300",
        className
      )}
      {...props}
    />
  );
};

export default Input;
